import React, { Component } from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import "./App.scss";
import Navbar from "./components/navigation";
import Home from "./components/home";
import About from "./components/about";
import Footer from "./components/footer";
import Culture from "./components/culture";
import Careers from "./components/careers";
import 'jquery/dist/jquery.min.js'
import 'bootstrap/dist/js/bootstrap.min.js'

class App extends Component {
  render() {
    return (
      <>
        <BrowserRouter>
          <Navbar></Navbar>
          <Switch>
            <Route path="/" exact component={Home} />
            <Route path="/about" exact component={About} />
            <Route path="/culture" exact component={Culture} />
            <Route path="/careers" exact component={Careers} />
          </Switch>
          <Footer></Footer>
        </BrowserRouter>
      </>
    );
  }
}

export default App;
